import { useEffect } from "react";

const SITE = process.env.REACT_APP_SITE_URL;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path = "/", noindex = false, jsonLd = null, image = null }) {
  useEffect(() => {
    const full = title.includes("KOUOH") ? title : `${title} | Atelier KOUOH`;
    document.title = full;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("name", "twitter:title", full);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("property", "og:image", image || `${SITE}/og-default.png`);
    setMeta("name", "twitter:image", image || `${SITE}/og-default.png`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${SITE}${path}`;
    document.getElementById("ld-json")?.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "ld-json";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, path, noindex, jsonLd, image]);
}

export const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Atelier KOUOH",
  legalName: "KOUOH",
  description: "Atelier de personnalisation textile : broderie, impression DTF, sérigraphie et broderie en direct lors d'événements.",
  url: SITE,
  address: { "@type": "PostalAddress", addressLocality: "Nice", postalCode: "06300", addressCountry: "FR" },
  areaServed: ["Nice", "Cannes", "Antibes", "Sophia Antipolis", "Cagnes-sur-Mer", "Saint-Laurent-du-Var", "Menton", { "@type": "Country", name: "Monaco" }],
};
